import type { Routes } from '@angular/router';

import { ADMIN_ROUTES } from '#modules/admin/routes/admin.routes';
import { USERS_ROUTES } from '#modules/user/routes/users.routes';

export const HEADER_ONLY_ROUTER_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/header-layout/header-layout.component').then((m) => m.HeaderLayoutComponent),
        children: [
            {
                path: 'users',
                loadChildren: () => USERS_ROUTES,
            },
            {
                path: 'admin',
                runGuardsAndResolvers: 'always',
                loadChildren: () => ADMIN_ROUTES,
            },
        ],
    },
];
